/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {},
    sizes: {
        book6Xlarge: (props) => ({
            ...props.theme.textStyles.book6Xlarge
        }),
        book5Xlarge: (props) => ({
            ...props.theme.textStyles.book5Xlarge
        }),
        book4Xlarge: (props) => ({
            ...props.theme.textStyles.book4Xlarge
        }),
        book3Xlarge: (props) => ({
            ...props.theme.textStyles.book3Xlarge
        }),
        book2Xlarge: (props) => ({
            ...props.theme.textStyles.book2Xlarge
        }),
        bookLarge: (props) => ({
            ...props.theme.textStyles.bookLarge
        }),
        bookMedium: (props) => ({
            ...props.theme.textStyles.bookMedium
        }),
        bookSmall: (props) => ({
            ...props.theme.textStyles.bookSmall
        }),
        medium6Xlarge: (props) => ({
            ...props.theme.textStyles.medium6Xlarge
        }),
        medium5Xlarge: (props) => ({
            ...props.theme.textStyles.medium5Xlarge
        }),
        medium4Xlarge: (props) => ({
            ...props.theme.textStyles.medium4Xlarge
        }),
        medium3Xlarge: (props) => ({
            ...props.theme.textStyles.medium3Xlarge
        }),
        medium2Xlarge: (props) => ({
            ...props.theme.textStyles.medium2Xlarge
        }),
        mediumXlarge: (props) => ({
            ...props.theme.textStyles.mediumXlarge
        }),
        mediumLarge: (props) => ({
            ...props.theme.textStyles.mediumLarge
        }),
        mediumSmall: (props) => ({
            ...props.theme.textStyles.mediumSmall
        })
    },
    variants: {}
}
